export const toFlatStr = (str1: any) => {
    return (str1 + '').trim().toLowerCase();
};

export const isEqualStr = (str1: any, str2: any) => {
    return toFlatStr(str1 + '') === toFlatStr(str2 + '');
};

export const containsAnySubStr = (searchStr: any, strArray: any[]) => {
    const flatSearchStr = toFlatStr(searchStr);
    let result = false;
    strArray.forEach((str) => {
        const compare = flatSearchStr.includes(toFlatStr(str));
        if (compare) {
            result = true;
        }
    });

    return result;
};

export const extractLeadingNumber = (string?: string): number | undefined => {
    if (!string) {
        return undefined;
    }

    const number = string.split(' ')[0];
    return parseInt(number);
};

export const getFormattedProduct = (product: string | undefined) => {
    return product
        ?.replace(/,?\s*Status\s*\d+/i, '')
        ?.replace(/,?\s*\d+% LTV/i, '');
};

/**
 * Extracts email from URL search string, handling + character properly
 * URLSearchParams may decode + as space, so we manually extract and decode
 */
export const getEmailFromUrl = (search: string): string => {
    const emailMatch = search.match(/[?&]email=([^&]*)/);
    if (emailMatch) {
        // Replace + with %2B before decoding to preserve + character
        const encodedEmail = emailMatch[1].replace(/\+/g, '%2B');
        return decodeURIComponent(encodedEmail);
    }
    return '';
};
